// /**
//  * Warwhouse - Add
//  */

// React
import React, { useState, useEffect } from "react";
// react hook form
import { useForm } from "react-hook-form";

// UI
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  TextField,
  Grid,
  Button,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  Typography,
  CircularProgress,
  Divider,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiClose,
  mdiCubeOutline,
  mdiNumeric,
  mdiCity,
  mdiArrowUpDown,
  mdiWidgetsOutline,
  mdiRuler,
  mdiCashMultiple,
} from "@mdi/js";

// Client SDK
import partnersRepository from "client-sdk/src/Repository/partners-repository";
import Autocomplete from "@material-ui/lab/Autocomplete";
import packagesManagementRepository from "client-sdk/src/Repository/packagesManagement-repository";
import handleError from "../../../utils/handleError";
import handleNotfication from "../../../utils/handleNotification";

type Props = {
  onClose: () => void;
  updateList: () => void;
  isOpen: boolean;
  id: number;
};

type Inputs = {
  name: string;
  code: string;
  owner: string;
  weight: string;
  length: string;
  width: string;
  height: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },

    item: {
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontWeight: 500,
      width: "100%",
    },
    icon: {
      color: "#8a8a8a",
      marginRight: theme.spacing(1),
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8a8a8a",
      marginRight: "8px",
      marginTop: "21px",
    },
    closeButton: {
      position: "absolute",
      right: "17px",
      zIndex: 10,
    },
  })
);

function Edit(props: Props) {
  const classes = useStyles();
  const { register, handleSubmit, errors, reset, getValues } = useForm<Inputs>({
    defaultValues: {
      name: "",
      code: "",
      weight: "",
      length: "",
      width: "",
      height: "",
    },
  });
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [owner, setOwner] = useState(null);
  const [postSizeId, setPostSizeId] = useState(null);

  useEffect(() => {
    if (props.id && props.id > 0) {
      getPackage();
    }
  }, [props]);

  const onSubmit = async (data: Inputs) => {
    const { postSizeId, ...restData } = data;

    const payload = {
      ...data,
      partnerId: owner?.id,
      id: props.id,
      postSize: postSizeId,
    };

    try {
      const response = await packagesManagementRepository.updatePackages({
        payload,
      });
      props.updateList();
      handleNotfication("بسته بندی با موفقیت ویرایش شد", "success");
      props.onClose();
    } catch (err) {
      handleError(err.response);
    }
  };

  const getPartners = async (data: any) => {
    setLoading(true);
    const { response } = await partnersRepository.getPartners({
      payload: {
        page: 0,
        size: 1000,
      },
    });
    setLoading(false);
    setOptions(response.data);
    setOwner(response.data.filter((el) => el.id == data.partnerId)[0]);
  };

  const getPackage = async () => {
    try {
      const response = await packagesManagementRepository.getSinglePackage({
        id: props.id,
      });
      reset(response.data);
      getPartners(response.data);
    } catch (err) {
      handleError(err.response);
    }
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="responsive-dialog-title"
      fullWidth
      maxWidth="md">
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <div className={classes.closeButton}>
            <IconButton aria-label="close" onClick={props.onClose}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <Typography variant="h5" style={{ margin: "20px 20px 0 0 " }}>
            ویرایش بسته‌بندی {props.id}
          </Typography>
          <div style={{ display: "flex" }}>
            <Grid
              container
              style={{ margin: "20px 0" }}
              spacing={5}
              alignItems="flex-start">
              <Grid
                style={{ padding: "20px" }}
                container
                spacing={5}
                alignItems="flex-start">
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCubeOutline}
                        size={1}
                        className={classes.icon}
                      />
                    </span>
                    <div style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        label="نام بسته‌بندی"
                        inputRef={register({ required: true })}
                        className={classes.textInput}
                        name="name"
                        id="name"
                        InputLabelProps={{
                          shrink: !!getValues().name,
                        }}
                        error={errors.name && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiNumeric}
                        size={1}
                        className={classes.icon}
                      />
                    </span>

                    <div style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="code"
                        name="code"
                        label="کد بسته‌بندی"
                        InputLabelProps={{
                          shrink: !!getValues().code,
                        }}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.code && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCity}
                        size={1}
                        className={classes.icon}
                        style={{ transform: "rotate(-90deg)" }}
                      />
                    </span>

                    <span style={{ width: "100%" }}>
                      <Autocomplete
                        getOptionSelected={(option, value) =>
                          option.name === value?.name
                        }
                        noOptionsText="مالکیتی وجود ندارد"
                        value={owner}
                        getOptionLabel={(option) => option.name}
                        options={options}
                        loading={loading}
                        onChange={(event: any, newValue: any | null) => {
                          setOwner(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="owner"
                            name="owner"
                            label="مالکیت"
                            inputRef={register({ required: true })}
                            className={classes.textInput}
                            error={errors.owner && true}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCity}
                        size={1}
                        className={classes.icon}
                        style={{ transform: "rotate(-90deg)" }}
                      />
                    </span>

                    <span style={{ width: "100%" }}>
                      <Autocomplete
                        getOptionSelected={(option, value) => option === value}
                        noOptionsText="سایزی وجود ندارد"
                        value={postSizeId}
                        getOptionLabel={(option) => option}
                        options={[
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                          "6",
                          "7",
                          "8",
                          "9",
                          "10",
                        ]}
                        onChange={(event: any, newValue: any | null) => {
                          setPostSizeId(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="postSizeId"
                            name="postSizeId"
                            label="سایز پستی"
                            inputRef={register({ required: true })}
                            error={errors.postSizeId && true}
                            className={classes.textInput}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiWidgetsOutline}
                        size={1}
                        className={classes.icon}
                        style={{ transform: "rotate(-180deg)" }}
                      />
                    </span>

                    <span style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="weight"
                        name="weight"
                        label="وزن"
                        InputLabelProps={{
                          shrink: !!getValues().weight,
                        }}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.weight && true}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={3} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon path={mdiRuler} size={1} className={classes.icon} />
                    </span>

                    <span style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="length"
                        name="length"
                        label="طول(سانتی‌متر)"
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.length && true}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={3} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon path={mdiRuler} size={1} className={classes.icon} />
                    </span>

                    <span style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="width"
                        name="width"
                        label="عرض(سانتی‌متر)"
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.width && true}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={3} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiArrowUpDown}
                        size={1}
                        className={classes.icon}
                      />
                    </span>

                    <span style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="height"
                        name="height"
                        label="ارتفاع(سانتی‌متر)"
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.height && true}
                      />
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={3} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCashMultiple}
                        size={1}
                        className={classes.icon}
                      />
                    </span>

                    <span style={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        id="price"
                        name="price"
                        label="قیمت"
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                        error={errors.price && true}
                      />
                    </span>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                variant="outlined"
                onClick={props.onClose}
                size="large">
                {"انصراف"}
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button
                fullWidth
                type="submit"
                autoFocus
                variant="contained"
                color="primary"
                size="large">
                ویرایش بسته‌بندی
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default Edit;
